/**
 * What a player reading the arranged part would call wrong, above the reading bar.
 *
 * The verdict is the book's rules for a chord, and an arrangement can pass every one of them
 * with a hand of a player of two hands left idle, a line that jumps an octave for a note, or a player given the
 * accompaniment's interlude as the tune. The pipeline reads the result for those once it is
 * arranged (`rk_keep_idiom`) and says each in words, with the count and the bars. Nothing was
 * changed by them and nothing here changes anything: they are for the reader to judge the
 * result by, beside the verdict.
 */

import type { KeptIdiom } from "@app/shared-types";
import { sentence } from "../lib/arrange-words";

export default function ArrangeIdiom({
  idiom,
}: {
  readonly idiom: readonly KeptIdiom[];
}): JSX.Element | null {
  if (idiom.length === 0) return null;
  return (
    <ul className="shrink-0 space-y-1 border-t border-shell-edge bg-shell-bar px-2.5 py-1.5 text-[11px] leading-relaxed text-shell-text">
      {idiom.map((one) => (
        <li key={`${one.check}:${one.said}`}>
          <span className="rounded border-l-2 border-unread bg-shell-key/60 px-2 py-0.5">
            {sentence(one.said)}.
          </span>
        </li>
      ))}
    </ul>
  );
}
